module.exports = __webpack_public_path__ + "img/wingo-logo-teal.4aa44844.svg";